import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { SignUpRequest } from "../model/user/sign-up-request";
import { UserType } from "../model/user/user-type";
import firebase from "firebase";
import { AuthService } from "../auth/auth.service";
import { UserService } from "src/service/user.service";
import { User } from "../model/user/user";
import { tap } from "rxjs/internal/operators/tap";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { switchMap } from "rxjs/operators";
import { JwtObj } from "../auth/jwt-obj";

@Injectable({
  providedIn: "root",
})
export class CreateUserService implements Resolve<User> {
  constructor(
    private authService: AuthService,
    private userService: UserService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): User | Observable<User> | Promise<User> {
    this.userType.next(this.getUserType());
    if (this.authService.isLoggedIn) {
      const jwtObj :JwtObj = this.authService.fetchJwt()
      return this.userService.isExist(jwtObj.uid)
      .pipe(switchMap(isExist=>{
        if(isExist){
          return this.userService.getUser();
        }else {
          return of(null)
        }
      }))
    }
    return null;
  }

  userType = new BehaviorSubject<UserType>(null);
  signUpRequest = new BehaviorSubject<SignUpRequest>(null);
  goingBack = false

  setUserType(userType: UserType) {
    this.userType.next(userType);
    localStorage.setItem("userType", JSON.stringify(userType));
  }

  getUserType() {
    return this.userType.value
      ? this.userType.value
      : JSON.parse(localStorage.getItem("userType"));
  }

  signUp = (value) =>
    this.userService
      .signUp(this.getSignUpRequest(value))
      .pipe(tap((user: User) => this.refreshUser(user)));

  getSignUpRequest({ name, surname, birthDate }): SignUpRequest {
    return {
      name,
      surname,
      birthDate,
      userType: UserType[this.getUserType()],
      email: firebase.auth().currentUser.email,
      phone: firebase.auth().currentUser.phoneNumber,
      userId: this.authService.fetchJwt().uid,
    };
  }

  updateUser(value) {
    this.userService.user.next({ ...this.userService.user.value, ...value });
    return this.userService
      .updateUser(this.userService.user.value)
      .pipe(tap((user: User) => this.refreshUser(user)));
  }

  refreshUser = (user: User) => this.userService.user.next(user);
}
